import PhotoImage1 from 'assets/images/photoImg1.png';
import PhotoImage2 from 'assets/images/photoImg2.png';

export const MAX_IMG_COUNT = 60;
export const USER_ROLES = {
  ADMIN: 'ADMIN',
  PRO: 'PRO USER',
};

export const SUBMISSION_PRO_STATUSES = {
  DRAFT: 'Draft',
  SUBMIT: 'Submitted',
  COMPLETE_SUBMISSION: 'Complete Submission',
  DECLINED: 'Declined',
  UPDATES_REQUESTED: 'Updates Requested',
  UPDATES_REQUESTED_B: 'Updates Requested FormB',
  ACCEPTED: 'Accepted',
  SCHEDULED: 'Scheduled',
  PUBLISHED: 'Published',
};

export const SUBMISSION_ADMIN_STATUSES = {
  FOR_REVIEW: 'For Review',
  FOR_COMPLETION: 'For Completion',
  ACCEPTED: 'Accepted',
  SCHEDULED: 'Scheduled',
  PUBLISHED: 'Published',
  DECLINED: 'Declined',
};

export const ERROR_MESSAGES = {
  NOT_FOUND_PAGE: 'Page Not Found. Try different route.',
  NO_ROLES_FOUND: 'No roles found. Please try again later.',
};

export const IMAGE_TAGS = {
  Setting: 'setting',
  Moments: 'moments',
  'Fashion & Beauty': 'fashion_beauty',
  Florals: 'florals',
  'Floral Type': 'floral_type',
  Decor: 'decor',
  Stationery: 'stationery',
  'Food & Drink': 'food_drink',
  Transportation: 'transportation',
};

export const IMAGE_COLORS = {
  White: '#fff',
  Silver: '#d2d2d2',
  Gray: '#777',
  Black: '#000',
  Copper: '#b65e2e',
  Ivory: '#efeae7',
  Beige: '#e0c39b',
  Brown: '#9d7b60',
  Gold: '#b28c4d',
  'Rose Gold': '#c37a6b',
  Blush: '#ecd8d9',
  Pink: '#dda3a2',
  Magenta: '#d66f8d',
  Red: '#d12c28',
  Orange: '#eb9a4b',
  Coral: '#e87465',
  Taupe: '#c8bbb8',
  Yellow: '#edcf49',
  Green: '#005826',
  Blue: '#3a57b5',
  Navy: '#170f6f',
  Teal: '#2d8e85',
  Lilac: '#a78fbb',
  Purple: '#5a085a',
  Rainbow: '#ff7099',
};

export const photoDummy = [
  {
    img: PhotoImage1,
    name: 'John Doe',
    email: 'john@doe.com',
    city: 'New York',
    state: 'New York',
    listingUrl: 'https://pro.aisleplanner.com/submissions',
    website: 'https://pro.aisleplanner.com/submissions',
  },
  {
    img: PhotoImage2,
    name: 'James Brown',
    email: 'james@brown.com',
    city: 'Los Angeles',
    state: 'CA',
    listingUrl: 'https://pro.aisleplanner.com/submissions',
    website: 'https://pro.aisleplanner.com/submissions',
  },
  {
    img: PhotoImage1,
    name: 'Ellon Musk',
    email: 'ellon@musk.com',
    city: 'Chicago',
    state: 'IL',
    listingUrl: 'https://pro.aisleplanner.com/submissions',
    website: 'https://pro.aisleplanner.com/submissions',
  },
  {
    img: PhotoImage2,
    name: 'Jeff Bezos',
    email: 'jeff@amazon.com',
    city: 'San Francisco',
    state: 'CA',
    listingUrl: 'https://pro.aisleplanner.com/submissions',
    website: 'https://pro.aisleplanner.com/submissions',
  },
  {
    img: PhotoImage1,
    name: 'John Lee',
    email: 'john@lee.com',
    city: 'Arlington',
    state: 'TX',
    listingUrl: 'https://pro.aisleplanner.com/submissions',
    website: 'https://pro.aisleplanner.com/submissions',
  },
];

export const CREDITS_INI_STATUSES = {
  couple: [
    { role: '', name: '', email: '' },
    { role: '', name: '', email: '' },
  ],
  vendors: [
    {
      name: '',
      email: '',
      website: '',
    },
  ],
  locations: [
    {
      place_id: '',
      formatted_address: '',
      company: '',
      website_url: '',
      city: '',
      state: '',
      location: '',
      email: '',
    },
  ],
  other_credit: [],
  vendor_unlinks: [],
};

export const OTHER_CATEGORY_LABELS = [
  { label: 'Accessories', value: 'accessories' },
  { label: 'Band', value: 'band' },
  { label: 'Bar', value: 'bar' },
  { label: 'Bridal Salon', value: 'bridalSalon' },
  { label: "Bride's Shoes", value: 'bridesShoes' },
  { label: "Bridesmaids' Dresses", value: 'bridesmaidsDresses' },
  { label: 'Cake', value: 'cake' },
  { label: 'Calligraphy', value: 'calligraphy' },
  { label: 'Catering', value: 'catering' },
  { label: 'Cinematography', value: 'cinematography' },
  { label: 'Dessert', value: 'Dessert' },
  { label: 'DJ', value: 'dj' },
  { label: 'Engagement Ring', value: 'engagementRing' },
  { label: 'Entertainment', value: 'entertainment' },
  { label: 'Equipment & Decor Rentals', value: 'equipmentAndDecorRent' },
  { label: 'Event Designer', value: 'eventDesigner' },
  { label: 'Event Stylist', value: 'eventStylist' },
  { label: 'Favors', value: 'favors' },
  { label: 'Floral Designer', value: 'floralDesigner' },
  { label: "Groom's attire", value: 'groomAttire' },
  { label: "Groom's shoes", value: 'groomShoes' },
  { label: "Groomsmen's attire", value: 'groomsmenAttire' },
  { label: 'Hair Stylist', value: 'hairStylist' },
  { label: 'Jewelry', value: 'jewelry' },
  { label: 'Lighting', value: 'lighting' },
  { label: 'Linens', value: 'linens' },
  { label: 'Makeup Artist', value: 'makeUpArtist' },
  { label: 'Model', value: 'model' },
  { label: 'Officiant', value: 'officiant' },
  { label: 'Photo Booth', value: 'photoBoth' },
  { label: 'Photographer', value: 'photographer' },
  { label: 'Stationery', value: 'stationery' },
  { label: 'Transportation', value: 'transportation' },
  { label: 'Wedding Dress', value: 'wDress' },
  { label: 'Wedding Planner', value: 'wPlanner' },
  { label: 'Wedding Rings', value: 'wRings' },
];

export const LOCATION_OPTIONS = [
  { label: 'Ceremony Location', value: 'ceremony' },
  { label: 'Reception Location', value: 'submitted' },
  { label: 'Ceremony & Reception Location', value: 'published' },
];

export const CREDIT_COUPLE_OPTIONS = [
  { label: 'Bride', value: 'bride' },
  { label: 'Groom', value: 'groom' },
  { label: 'Partner', value: 'partner' },
];

export const SUBMISSION_CATEGORIES = {
  real_wedding: 'Real Wedding',
  styled_shoot: 'Styled Shoot',
};

export const TIME_FORMATS = [
  {
    label: '12 hour',
    value: '12',
  },
  {
    label: '24 hour',
    value: '24',
  },
];

export const DATE_FORMATS = [
  {
    label: 'MM/DD/YYYY',
    value: 'mm/dd/yyyy',
    format: 'MM-DD-YYYY',
  },
  {
    label: 'DD/MM/YYYY',
    value: 'dd/mm/yyyy',
    format: 'DD-MM-YYYY',
  },
  {
    label: 'YYYY/MM/DD',
    value: 'yyyy/mm/dd',
    format: 'YYYY-MM-DD',
  },
];

export const CURRENCIES = [
  {
    value: 'USD',
    label: 'US Dollar',
    symbol: '$',
    decimal_sep: '.',
    group_sep: ',',
    format: '$%s',
    unique_format: '$%s',
    decimal_places: 2,
    minimum_payment_amount: 50,
  },
  {
    value: 'EUR',
    label: 'Euro',
    symbol: '\u20ac',
    decimal_sep: ',',
    group_sep: '.',
    format: '\u20ac%s',
    unique_format: '\u20ac%s',
    decimal_places: 2,
    minimum_payment_amount: 50,
  },
  {
    value: 'AUD',
    label: 'Australian Dollar',
    symbol: '$',
    decimal_sep: '.',
    group_sep: ',',
    format: '$%s',
    unique_format: '$%s AUD',
    decimal_places: 2,
    minimum_payment_amount: 50,
  },
  {
    value: 'BSD',
    label: 'Bahamian Dollar',
    symbol: '$',
    decimal_sep: '.',
    group_sep: ',',
    format: '$%s',
    unique_format: '$%s BSD',
    decimal_places: 2,
  },
  {
    value: 'BDD',
    label: 'Barbadian Dollar',
    symbol: '$',
    decimal_sep: '.',
    group_sep: ',',
    format: '$%s',
    unique_format: '$%s BDD',
    decimal_places: 2,
  },
  {
    value: 'BMD',
    label: 'Bermudian Dollar',
    symbol: '$',
    decimal_sep: '.',
    group_sep: ',',
    format: '$%s',
    unique_format: '$%s BMD',
    decimal_places: 2,
  },
  {
    value: 'BRL',
    label: 'Brazilian Real',
    symbol: 'R$',
    decimal_sep: ',',
    group_sep: '.',
    format: 'R$%s',
    unique_format: 'R$%s',
    decimal_places: 2,
  },
  {
    value: 'GBP',
    label: 'British Pound Sterling',
    symbol: '\u00a3',
    decimal_sep: '.',
    group_sep: ',',
    format: '\u00a3%s',
    unique_format: '\u00a3%s',
    decimal_places: 2,
    minimum_payment_amount: 30,
  },
  {
    value: 'CAD',
    label: 'Canadian Dollar',
    symbol: '$',
    decimal_sep: '.',
    group_sep: ',',
    format: '$%s',
    unique_format: '$%s CAD',
    decimal_places: 2,
    minimum_payment_amount: 50,
  },
  {
    value: 'KYD',
    label: 'Cayman Islands Dollar',
    symbol: '$',
    decimal_sep: '.',
    group_sep: ',',
    format: '$%s',
    unique_format: '$%s KYD',
    decimal_places: 2,
  },
  {
    value: 'CNY',
    label: 'Chinese Yuan',
    symbol: '\u00a5',
    decimal_sep: '.',
    group_sep: ',',
    format: '\u00a5%s',
    unique_format: '\u00a5%s CNY',
    decimal_places: 2,
  },
  {
    value: 'HRK',
    label: 'Croatian Kuna',
    symbol: 'kn',
    decimal_sep: ',',
    group_sep: '.',
    format: '%s kn',
    unique_format: '%s kn',
    decimal_places: 2,
  },
  {
    value: 'ANG',
    label: 'Curacao - Netherlands Antillean Guilder',
    symbol: '\u0192',
    decimal_sep: ',',
    group_sep: '.',
    format: '\u0192%s',
    unique_format: '\u0192%s',
    decimal_places: 2,
  },
  {
    value: 'DKK',
    label: 'Danish Krone',
    symbol: 'kr',
    decimal_sep: ',',
    group_sep: '.',
    format: '%s kr',
    unique_format: '%s kr DKK',
    decimal_places: 2,
    minimum_payment_amount: 250,
  },
  {
    value: 'GHC',
    label: 'Ghanaian Cedi',
    symbol: '\u00a2',
    decimal_sep: '.',
    group_sep: ',',
    format: '\u00a2%s',
    unique_format: '\u00a2%s',
    decimal_places: 2,
  },
  {
    value: 'GTQ',
    label: 'Guatemalan Quetzal',
    symbol: 'Q',
    decimal_sep: '.',
    group_sep: ',',
    format: 'Q %s',
    unique_format: 'Q %s',
    decimal_places: 2,
  },
  {
    value: 'HKD',
    label: 'Hong Kong Dollar',
    symbol: '$',
    decimal_sep: '.',
    group_sep: ',',
    format: '$%s',
    unique_format: '$%s HKD',
    decimal_places: 2,
    minimum_payment_amount: 400,
  },
  {
    value: 'HUF',
    label: 'Hungarian Forint',
    symbol: 'Ft',
    decimal_sep: '.',
    group_sep: ',',
    format: 'Ft %s',
    unique_format: 'Ft %s',
    decimal_places: 2,
  },
  {
    value: 'IDR',
    label: 'Indonesian Rupiah',
    symbol: 'Rp',
    decimal_sep: ',',
    group_sep: '.',
    format: 'Rp %s',
    unique_format: 'Rp %s',
    decimal_places: 2,
  },
  {
    value: 'LBP',
    label: 'Lebanese Pound',
    symbol: '\u00a3',
    decimal_sep: '.',
    group_sep: ' ',
    format: '\u00a3%s',
    unique_format: '\u00a3%s LBP',
    decimal_places: 2,
  },
  {
    value: 'JPY',
    label: 'Japanese Yen',
    symbol: '\u00a5',
    decimal_sep: '.',
    group_sep: ',',
    format: '\u00a5%s',
    unique_format: '\u00a5%s JPY',
    decimal_places: 0,
    minimum_payment_amount: 5000,
  },
  {
    value: 'MYR',
    label: 'Malaysian Ringgit',
    symbol: 'RM',
    decimal_sep: '.',
    group_sep: ',',
    format: 'RM %s',
    unique_format: 'RM %s',
    decimal_places: 2,
  },
  {
    value: 'MXN',
    label: 'Mexican Peso',
    symbol: '$',
    decimal_sep: '.',
    group_sep: ',',
    format: '$%s',
    unique_format: '$%s MXN',
    decimal_places: 2,
    minimum_payment_amount: 1000,
  },
  {
    value: 'NOK',
    label: 'Norwegian Krone',
    symbol: 'kr',
    decimal_sep: ',',
    group_sep: ' ',
    format: '%s kr',
    unique_format: '%s kr NOK',
    decimal_places: 2,
    minimum_payment_amount: 300,
  },
  {
    value: 'NZD',
    label: 'New Zealand Dollar',
    symbol: '$',
    decimal_sep: '.',
    group_sep: ',',
    format: '$%s',
    unique_format: '$%s NZD',
    decimal_places: 2,
    minimum_payment_amount: 50,
  },
  {
    value: 'PLN',
    label: 'Polish Zloty',
    symbol: 'zł',
    decimal_sep: '.',
    group_sep: ',',
    format: 'zł%s',
    unique_format: 'zł%s PLN',
    decimal_places: 2,
    minimum_payment_amount: 50,
  },
  {
    value: 'PHP',
    label: 'Philippine Peso',
    symbol: '₱',
    decimal_sep: '.',
    group_sep: ',',
    format: '₱%s',
    unique_format: '₱%s PHP',
    decimal_places: 2,
    minimum_payment_amount: 50,
  },
  {
    value: 'ROL',
    label: 'Romanian Leu',
    symbol: 'lei',
    decimal_sep: ',',
    group_sep: '.',
    format: '%s lei',
    unique_format: '%s lei',
    decimal_places: 2,
  },
  {
    value: 'SGD',
    label: 'Singapore Dollar',
    symbol: '$',
    decimal_sep: '.',
    group_sep: ',',
    format: '$%s',
    unique_format: '$%s SGD',
    decimal_places: 2,
    minimum_payment_amount: 50,
  },
  {
    value: 'ZAR',
    label: 'South African Rand',
    symbol: 'R',
    decimal_sep: '.',
    group_sep: ' ',
    format: 'R %s',
    unique_format: 'R %s',
    decimal_places: 2,
  },
  {
    value: 'SEK',
    label: 'Swedish Krona',
    symbol: 'kr',
    decimal_sep: ',',
    group_sep: ' ',
    format: '%s kr',
    unique_format: '%s kr SEK',
    decimal_places: 2,
    minimum_payment_amount: 300,
  },
  {
    value: 'CHF',
    label: 'Swiss Franc',
    symbol: 'fr',
    decimal_sep: '.',
    group_sep: "'",
    format: '%s fr',
    unique_format: '%s fr',
    decimal_places: 2,
    minimum_payment_amount: 50,
  },
  {
    value: 'TWD',
    label: 'New Taiwan Dollar',
    symbol: 'NT$',
    decimal_sep: '.',
    group_sep: ',',
    format: 'NT$%s',
    unique_format: 'NT$%s',
    decimal_places: 2,
  },
  {
    value: 'THB',
    label: 'Thai Baht',
    symbol: '\u0e3f',
    decimal_sep: '.',
    group_sep: ',',
    format: '\u0e3f%s',
    unique_format: '\u0e3f%s',
    decimal_places: 2,
  },
  {
    value: 'TDD',
    label: 'Trinidad and Tobago Dollar',
    symbol: 'TT$',
    decimal_sep: '.',
    group_sep: ',',
    format: 'TT$%s',
    unique_format: 'TT$%s',
    decimal_places: 2,
  },
  {
    value: 'AED',
    label: 'United Arab Emirates Dirham',
    symbol: '',
    decimal_sep: '.',
    group_sep: ',',
    format: 'AED %s',
    unique_format: 'AED %s',
    decimal_places: 2,
  },
];

export const FULL_LEADS_HEADERS = {
  contactName: 'Lead Name',
  contactEmail: 'Email',
  contactNumber: 'Phone #',
  projectName: 'Project Name',
  eventDate: 'Event Date',
  eventLocation: 'Location',
  contactCompanyName: 'Company Name',
  serviceType: 'Service Type',
  estimateBudget: 'Budget',
  dateInquiry: 'Inquiry Date',
  leadSource: 'Lead Source',
  leadAssignments: 'Lead Assignments',
  status: 'Status',
  lastContactedDate: 'Last Contacted',
  lostReasonId: 'Lost Reason',
};

export const INITIAL_LEADS_HEADERS = {
  contactName: 'Lead Name',
  contactEmail: 'Email',
  contactNumber: 'Phone #',
  projectName: 'Project Name',
  eventDate: 'Event Date',
  eventLocation: 'Location',
  serviceType: 'Service Type',
  estimateBudget: 'Budget',
  status: 'Status',
};

export const LEADS_VIEW_OPTIONS = [
  {
    id: 'contactName',
    name: 'Lead Name',
    checked: true,
  },
  {
    id: 'contactEmail',
    name: 'Email',
    checked: true,
  },
  {
    id: 'contactNumber',
    name: 'Phone #',
    checked: true,
  },
  {
    id: 'contactCompanyName',
    name: 'Company Name',
    checked: false,
  },
  {
    id: 'projectName',
    name: 'Project Name',
    checked: true,
  },
  {
    id: 'eventDate',
    name: 'Event Date',
    checked: true,
  },
  {
    id: 'eventLocation',
    name: 'Location',
    checked: true,
  },
  {
    id: 'serviceType',
    name: 'Service Type',
    checked: true,
  },
  {
    id: 'estimateBudget',
    name: 'Budget',
    checked: true,
  },
  {
    id: 'dateInquiry',
    name: 'Inquiry Date',
    checked: true,
  },
  {
    id: 'leadSource',
    name: 'Lead Source',
    checked: true,
  },
  {
    id: 'leadAssignments',
    name: 'Lead Assignments',
    checked: true,
  },
  {
    id: 'status',
    name: 'Status',
    checked: true,
  },
  {
    id: 'lastContactedDate',
    name: 'Last Contacted',
    checked: true,
  },
  {
    id: 'lostReasonId',
    name: 'Lost Reason',
    checked: true,
  },
];

export const LEADS_DOWNLOAD_FIELDS = [
  {
    id: 'contactName',
    param: ['first_name', 'last_name'],
    name: 'Name',
  },
  {
    id: 'email',
    param: ['email'],
    name: 'Email',
  },
  {
    id: 'phone',
    param: ['phone'],
    name: 'Phone Number',
  },
  {
    id: 'address',
    param: ['address'],
    name: 'Address',
  },
  {
    id: 'website',
    param: ['website'],
    name: 'Website',
  },
  {
    id: 'company',
    param: ['company'],
    name: 'Company',
  },
  {
    id: 'role',
    param: ['role'],
    name: 'Role',
  },
  {
    id: 'dateInquire',
    param: ['date_of_inquiry'],
    name: 'Inquiry Date',
  },
  {
    id: 'lastContactedDate',
    param: ['last_contacted'],
    name: 'Last Contacted',
  },
  {
    id: 'status',
    param: ['status'],
    name: 'Status',
  },
  {
    id: 'projectName',
    param: ['project_name'],
    name: 'Project Name',
  },
  {
    id: 'serviceType',
    param: ['service_type'],
    name: 'Service Type',
  },
  {
    id: 'eventDate',
    param: ['event_date'],
    name: 'Event Date',
  },
  {
    id: 'venueName',
    param: ['venue_name'],
    name: 'Venue Name',
  },
  {
    id: 'venueLocation',
    param: ['venue_location_city', 'venue_location_state'],
    name: 'Venue Location',
  },
  {
    id: 'budget',
    param: ['budget'],
    name: 'Budget',
  },
  {
    id: 'guestCount',
    param: ['guest_count'],
    name: 'Guest Count',
  },
  {
    id: 'leadSource',
    param: ['lead_source'],
    name: 'Lead Source',
  },
  {
    id: 'leadAssignment',
    param: ['lead_assignment'],
    name: 'Lead Assignments',
  },
  {
    id: 'notes',
    param: ['notes'],
    name: 'Notes',
  },
  {
    id: 'lostReason',
    param: ['lost_reason'],
    name: 'Lost Reason',
  },
];

export const PROJECTS_DOWNLOAD_VIEW_OPTIONS = [
  {
    id: 'projectName',
    name: 'Project Name',
    checked: true,
  },
  {
    id: 'projectDate',
    name: 'Project Date',
    checked: true,
  },
  {
    id: 'serviceType',
    name: 'Service Type',
    checked: true,
  },
  {
    id: 'client',
    name: 'Client',
    checked: true,
  },
  {
    id: 'clientPhone',
    name: 'Client Phone',
    checked: true,
  },
  {
    id: 'clientEmail',
    name: 'Client Email',
    checked: true,
  },
  {
    id: 'location',
    name: 'Location',
    checked: true,
  },
  {
    id: 'city',
    name: 'City',
    checked: true,
  },
  {
    id: 'state',
    name: 'State',
    checked: true,
  },
  {
    id: 'projectLead',
    name: 'Project Lead',
    checked: true,
  },
  {
    id: 'guestCount',
    name: 'Guest Count',
    checked: true,
  },
  {
    id: 'budget',
    name: 'Budget',
    checked: true,
  },
];

export const PROJECTS_DOWNLOAD_FIELDS = [
  {
    id: 'projectName',
    param: ['project_name'],
    name: 'Project Name',
  },
  {
    id: 'projectDate',
    param: ['project_date'],
    name: 'Project Date',
  },
  {
    id: 'serviceType',
    param: ['service_type'],
    name: 'Service Type',
  },
  {
    id: 'client',
    param: ['client'],
    name: 'Client',
  },
  {
    id: 'clientPhone',
    param: ['client_phone'],
    name: 'Client Phone',
  },
  {
    id: 'clientEmail',
    param: ['client_email'],
    name: 'Client Email',
  },
  {
    id: 'location',
    param: ['location'],
    name: 'Location',
  },
  {
    id: 'city',
    param: ['city'],
    name: 'City',
  },
  {
    id: 'state',
    param: ['state'],
    name: 'State',
  },
  {
    id: 'projectLead',
    param: ['project_lead'],
    name: 'Project Lead',
  },
  {
    id: 'guestCount',
    param: ['guest_count'],
    name: 'Guest Count',
  },
  {
    id: 'budget',
    param: ['budget'],
    name: 'Budget',
  },
];

export const TIME_ZONES = [
  {
    group: 'US',
    value: 'America/New_York',
    label: 'Eastern',
  },
  {
    group: 'US',
    value: 'America/Chicago',
    label: 'Central',
  },
  {
    group: 'US',
    value: 'America/Denver',
    label: 'Mountain',
  },
  {
    group: 'US',
    value: 'America/Los_Angeles',
    label: 'Pacific',
  },
  {
    group: 'US',
    value: 'America/Anchorage',
    label: 'Alaska',
  },
  {
    group: 'US',
    value: 'America/Phoenix',
    label: 'Arizona',
  },
  {
    group: 'US',
    value: 'Pacific/Honolulu',
    label: 'Hawaii',
  },
  {
    group: 'Canada',
    value: 'America/Atikokan',
    label: 'Atikokan',
  },
  {
    group: 'Canada',
    value: 'America/Blanc-Sablon',
    label: 'Blanc-Sablon',
  },
  {
    group: 'Canada',
    value: 'America/Cambridge_Bay',
    label: 'Cambridge Bay',
  },
  {
    group: 'Canada',
    value: 'America/Creston',
    label: 'Creston',
  },
  {
    group: 'Canada',
    value: 'America/Dawson',
    label: 'Dawson',
  },
  {
    group: 'Canada',
    value: 'America/Dawson_Creek',
    label: 'Dawson Creek',
  },
  {
    group: 'Canada',
    value: 'America/Edmonton',
    label: 'Edmonton',
  },
  {
    group: 'Canada',
    value: 'America/Glace_Bay',
    label: 'Glace Bay',
  },
  {
    group: 'Canada',
    value: 'America/Goose_Bay',
    label: 'Goose Bay',
  },
  {
    group: 'Canada',
    value: 'America/Halifax',
    label: 'Halifax',
  },
  {
    group: 'Canada',
    value: 'America/Inuvik',
    label: 'Inuvik',
  },
  {
    group: 'Canada',
    value: 'America/Iqaluit',
    label: 'Iqaluit',
  },
  {
    group: 'Canada',
    value: 'America/Moncton',
    label: 'Moncton',
  },
  {
    group: 'Canada',
    value: 'America/Montreal',
    label: 'Montreal',
  },
  {
    group: 'Canada',
    value: 'America/Nipigon',
    label: 'Nipigon',
  },
  {
    group: 'Canada',
    value: 'America/Pangnirtung',
    label: 'Pangnirtung',
  },
  {
    group: 'Canada',
    value: 'America/Rainy_River',
    label: 'Rainy River',
  },
  {
    group: 'Canada',
    value: 'America/Rankin_Inlet',
    label: 'Rankin Inlet',
  },
  {
    group: 'Canada',
    value: 'America/Regina',
    label: 'Regina',
  },
  {
    group: 'Canada',
    value: 'America/Resolute',
    label: 'Resolute',
  },
  {
    group: 'Canada',
    value: 'America/St_Johns',
    label: 'St Johns',
  },
  {
    group: 'Canada',
    value: 'America/Swift_Current',
    label: 'Swift Current',
  },
  {
    group: 'Canada',
    value: 'America/Thunder_Bay',
    label: 'Thunder Bay',
  },
  {
    group: 'Canada',
    value: 'America/Toronto',
    label: 'Toronto',
  },
  {
    group: 'Canada',
    value: 'America/Vancouver',
    label: 'Vancouver',
  },
  {
    group: 'Canada',
    value: 'America/Whitehorse',
    label: 'Whitehorse',
  },
  {
    group: 'Canada',
    value: 'America/Winnipeg',
    label: 'Winnipeg',
  },
  {
    group: 'Canada',
    value: 'America/Yellowknife',
    label: 'Yellowknife',
  },
  {
    group: 'Mexico',
    value: 'America/Bahia_Banderas',
    label: 'Bahia Banderas',
  },
  {
    group: 'Mexico',
    value: 'America/Cancun',
    label: 'Cancun',
  },
  {
    group: 'Mexico',
    value: 'America/Chihuahua',
    label: 'Chihuahua',
  },
  {
    group: 'Mexico',
    value: 'America/Hermosillo',
    label: 'Hermosillo',
  },
  {
    group: 'Mexico',
    value: 'America/Matamoros',
    label: 'Matamoros',
  },
  {
    group: 'Mexico',
    value: 'America/Mazatlan',
    label: 'Mazatlan',
  },
  {
    group: 'Mexico',
    value: 'America/Merida',
    label: 'Merida',
  },
  {
    group: 'Mexico',
    value: 'America/Mexico_City',
    label: 'Mexico City',
  },
  {
    group: 'Mexico',
    value: 'America/Monterrey',
    label: 'Monterrey',
  },
  {
    group: 'Mexico',
    value: 'America/Ojinaga',
    label: 'Ojinaga',
  },
  {
    group: 'Mexico',
    value: 'America/Santa_Isabel',
    label: 'Santa Isabel',
  },
  {
    group: 'Mexico',
    value: 'America/Tijuana',
    label: 'Tijuana',
  },
  {
    group: 'Americas',
    value: 'America/Anguilla',
    label: 'Anguilla',
  },
  {
    group: 'Americas',
    value: 'America/Antigua',
    label: 'Antigua',
  },
  {
    group: 'Americas',
    value: 'America/Araguaina',
    label: 'Araguaina',
  },
  {
    group: 'Americas',
    value: 'America/Aruba',
    label: 'Aruba',
  },
  {
    group: 'Americas',
    value: 'America/Asuncion',
    label: 'Asuncion',
  },
  {
    group: 'Americas',
    value: 'America/Bahia',
    label: 'Bahia',
  },
  {
    group: 'Americas',
    value: 'America/Barbados',
    label: 'Barbados',
  },
  {
    group: 'Americas',
    value: 'America/Belem',
    label: 'Belem',
  },
  {
    group: 'Americas',
    value: 'America/Belize',
    label: 'Belize',
  },
  {
    group: 'Americas',
    value: 'America/Boa_Vista',
    label: 'Boa Vista',
  },
  {
    group: 'Americas',
    value: 'America/Bogota',
    label: 'Bogota',
  },
  {
    group: 'Americas',
    value: 'America/Campo_Grande',
    label: 'Campo Grande',
  },
  {
    group: 'Americas',
    value: 'America/Caracas',
    label: 'Caracas',
  },
  {
    group: 'Americas',
    value: 'America/Cayenne',
    label: 'Cayenne',
  },
  {
    group: 'Americas',
    value: 'America/Cayman',
    label: 'Cayman',
  },
  {
    group: 'Americas',
    value: 'America/Costa_Rica',
    label: 'Costa Rica',
  },
  {
    group: 'Americas',
    value: 'America/Cuiaba',
    label: 'Cuiaba',
  },
  {
    group: 'Americas',
    value: 'America/Curacao',
    label: 'Curacao',
  },
  {
    group: 'Americas',
    value: 'America/Danmarkshavn',
    label: 'Danmarkshavn',
  },
  {
    group: 'Americas',
    value: 'America/Dominica',
    label: 'Dominica',
  },
  {
    group: 'Americas',
    value: 'America/Eirunepe',
    label: 'Eirunepe',
  },
  {
    group: 'Americas',
    value: 'America/El_Salvador',
    label: 'El Salvador',
  },
  {
    group: 'Americas',
    value: 'America/Fortaleza',
    label: 'Fortaleza',
  },
  {
    group: 'Americas',
    value: 'America/Godthab',
    label: 'Godthab',
  },
  {
    group: 'Americas',
    value: 'America/Grand_Turk',
    label: 'Grand Turk',
  },
  {
    group: 'Americas',
    value: 'America/Grenada',
    label: 'Grenada',
  },
  {
    group: 'Americas',
    value: 'America/Guadeloupe',
    label: 'Guadeloupe',
  },
  {
    group: 'Americas',
    value: 'America/Guatemala',
    label: 'Guatemala',
  },
  {
    group: 'Americas',
    value: 'America/Guayaquil',
    label: 'Guayaquil',
  },
  {
    group: 'Americas',
    value: 'America/Guyana',
    label: 'Guyana',
  },
  {
    group: 'Americas',
    value: 'America/Havana',
    label: 'Havana',
  },
  {
    group: 'Americas',
    value: 'America/Jamaica',
    label: 'Jamaica',
  },
  {
    group: 'Americas',
    value: 'America/La_Paz',
    label: 'La Paz',
  },
  {
    group: 'Americas',
    value: 'America/Lima',
    label: 'Lima',
  },
  {
    group: 'Americas',
    value: 'America/Maceio',
    label: 'Maceio',
  },
  {
    group: 'Americas',
    value: 'America/Managua',
    label: 'Managua',
  },
  {
    group: 'Americas',
    value: 'America/Manaus',
    label: 'Manaus',
  },
  {
    group: 'Americas',
    value: 'America/Martinique',
    label: 'Martinique',
  },
  {
    group: 'Americas',
    value: 'America/Miquelon',
    label: 'Miquelon',
  },
  {
    group: 'Americas',
    value: 'America/Montevideo',
    label: 'Montevideo',
  },
  {
    group: 'Americas',
    value: 'America/Montserrat',
    label: 'Montserrat',
  },
  {
    group: 'Americas',
    value: 'America/Nassau',
    label: 'Nassau',
  },
  {
    group: 'Americas',
    value: 'America/Noronha',
    label: 'Noronha',
  },
  {
    group: 'Americas',
    value: 'America/Panama',
    label: 'Panama',
  },
  {
    group: 'Americas',
    value: 'America/Paramaribo',
    label: 'Paramaribo',
  },
  {
    group: 'Americas',
    value: 'America/Port-au-Prince',
    label: 'Port-au-Prince',
  },
  {
    group: 'Americas',
    value: 'America/Port_of_Spain',
    label: 'Port of Spain',
  },
  {
    group: 'Americas',
    value: 'America/Porto_Velho',
    label: 'Porto Velho',
  },
  {
    group: 'Americas',
    value: 'America/Puerto_Rico',
    label: 'Puerto Rico',
  },
  {
    group: 'Americas',
    value: 'America/Recife',
    label: 'Recife',
  },
  {
    group: 'Americas',
    value: 'America/Rio_Branco',
    label: 'Rio Branco',
  },
  {
    group: 'Americas',
    value: 'America/Santarem',
    label: 'Santarem',
  },
  {
    group: 'Americas',
    value: 'America/Santiago',
    label: 'Santiago',
  },
  {
    group: 'Americas',
    value: 'America/Santo_Domingo',
    label: 'Santo Domingo',
  },
  {
    group: 'Americas',
    value: 'America/Sao_Paulo',
    label: 'Sao Paulo',
  },
  {
    group: 'Americas',
    value: 'America/Scoresbysund',
    label: 'Scoresbysund',
  },
  {
    group: 'Americas',
    value: 'America/St_Kitts',
    label: 'St Kitts',
  },
  {
    group: 'Americas',
    value: 'America/St_Lucia',
    label: 'St Lucia',
  },
  {
    group: 'Americas',
    value: 'America/St_Thomas',
    label: 'St Thomas',
  },
  {
    group: 'Americas',
    value: 'America/St_Vincent',
    label: 'St Vincent',
  },
  {
    group: 'Americas',
    value: 'America/Tegucigalpa',
    label: 'Tegucigalpa',
  },
  {
    group: 'Americas',
    value: 'America/Thule',
    label: 'Thule',
  },
  {
    group: 'Americas',
    value: 'America/Tortola',
    label: 'Tortola',
  },
  {
    group: 'Argentina',
    value: 'America/Argentina/Buenos_Aires',
    label: 'Buenos Aires',
  },
  {
    group: 'Argentina',
    value: 'America/Argentina/Catamarca',
    label: 'Catamarca',
  },
  {
    group: 'Argentina',
    value: 'America/Argentina/Cordoba',
    label: 'Cordoba',
  },
  {
    group: 'Argentina',
    value: 'America/Argentina/Jujuy',
    label: 'Jujuy',
  },
  {
    group: 'Argentina',
    value: 'America/Argentina/La_Rioja',
    label: 'La Rioja',
  },
  {
    group: 'Argentina',
    value: 'America/Argentina/Mendoza',
    label: 'Mendoza',
  },
  {
    group: 'Argentina',
    value: 'America/Argentina/Rio_Gallegos',
    label: 'Rio Gallegos',
  },
  {
    group: 'Argentina',
    value: 'America/Argentina/Salta',
    label: 'Salta',
  },
  {
    group: 'Argentina',
    value: 'America/Argentina/San_Juan',
    label: 'San Juan',
  },
  {
    group: 'Argentina',
    value: 'America/Argentina/San_Luis',
    label: 'San Luis',
  },
  {
    group: 'Argentina',
    value: 'America/Argentina/Tucuman',
    label: 'Tucuman',
  },
  {
    group: 'Argentina',
    value: 'America/Argentina/Ushuaia',
    label: 'Ushuaia',
  },
  {
    group: 'Europe',
    value: 'Europe/Amsterdam',
    label: 'Amsterdam',
  },
  {
    group: 'Europe',
    value: 'Europe/Andorra',
    label: 'Andorra',
  },
  {
    group: 'Europe',
    value: 'Europe/Athens',
    label: 'Athens',
  },
  {
    group: 'Europe',
    value: 'Europe/Belgrade',
    label: 'Belgrade',
  },
  {
    group: 'Europe',
    value: 'Europe/Berlin',
    label: 'Berlin',
  },
  {
    group: 'Europe',
    value: 'Europe/Brussels',
    label: 'Brussels',
  },
  {
    group: 'Europe',
    value: 'Europe/Bucharest',
    label: 'Bucharest',
  },
  {
    group: 'Europe',
    value: 'Europe/Budapest',
    label: 'Budapest',
  },
  {
    group: 'Europe',
    value: 'Europe/Chisinau',
    label: 'Chisinau',
  },
  {
    group: 'Europe',
    value: 'Europe/Copenhagen',
    label: 'Copenhagen',
  },
  {
    group: 'Europe',
    value: 'Europe/Dublin',
    label: 'Dublin',
  },
  {
    group: 'Europe',
    value: 'Europe/Gibraltar',
    label: 'Gibraltar',
  },
  {
    group: 'Europe',
    value: 'Europe/Helsinki',
    label: 'Helsinki',
  },
  {
    group: 'Europe',
    value: 'Europe/Istanbul',
    label: 'Istanbul',
  },
  {
    group: 'Europe',
    value: 'Europe/Kaliningrad',
    label: 'Kaliningrad',
  },
  {
    group: 'Europe',
    value: 'Europe/Kiev',
    label: 'Kiev',
  },
  {
    group: 'Europe',
    value: 'Europe/Lisbon',
    label: 'Lisbon',
  },
  {
    group: 'Europe',
    value: 'Europe/London',
    label: 'London',
  },
  {
    group: 'Europe',
    value: 'Europe/Luxembourg',
    label: 'Luxembourg',
  },
  {
    group: 'Europe',
    value: 'Europe/Madrid',
    label: 'Madrid',
  },
  {
    group: 'Europe',
    value: 'Europe/Malta',
    label: 'Malta',
  },
  {
    group: 'Europe',
    value: 'Europe/Minsk',
    label: 'Minsk',
  },
  {
    group: 'Europe',
    value: 'Europe/Monaco',
    label: 'Monaco',
  },
  {
    group: 'Europe',
    value: 'Europe/Moscow',
    label: 'Moscow',
  },
  {
    group: 'Europe',
    value: 'Europe/Oslo',
    label: 'Oslo',
  },
  {
    group: 'Europe',
    value: 'Europe/Paris',
    label: 'Paris',
  },
  {
    group: 'Europe',
    value: 'Europe/Prague',
    label: 'Prague',
  },
  {
    group: 'Europe',
    value: 'Europe/Riga',
    label: 'Riga',
  },
  {
    group: 'Europe',
    value: 'Europe/Rome',
    label: 'Rome',
  },
  {
    group: 'Europe',
    value: 'Europe/Samara',
    label: 'Samara',
  },
  {
    group: 'Europe',
    value: 'Europe/Simferopol',
    label: 'Simferopol',
  },
  {
    group: 'Europe',
    value: 'Europe/Sofia',
    label: 'Sofia',
  },
  {
    group: 'Europe',
    value: 'Europe/Stockholm',
    label: 'Stockholm',
  },
  {
    group: 'Europe',
    value: 'Europe/Tallinn',
    label: 'Tallinn',
  },
  {
    group: 'Europe',
    value: 'Europe/Tirane',
    label: 'Tirane',
  },
  {
    group: 'Europe',
    value: 'Europe/Uzhgorod',
    label: 'Uzhgorod',
  },
  {
    group: 'Europe',
    value: 'Europe/Vaduz',
    label: 'Vaduz',
  },
  {
    group: 'Europe',
    value: 'Europe/Vienna',
    label: 'Vienna',
  },
  {
    group: 'Europe',
    value: 'Europe/Vilnius',
    label: 'Vilnius',
  },
  {
    group: 'Europe',
    value: 'Europe/Volgograd',
    label: 'Volgograd',
  },
  {
    group: 'Europe',
    value: 'Europe/Warsaw',
    label: 'Warsaw',
  },
  {
    group: 'Europe',
    value: 'Europe/Zaporozhye',
    label: 'Zaporozhye',
  },
  {
    group: 'Europe',
    value: 'Europe/Zurich',
    label: 'Zurich',
  },
  {
    group: 'Asia',
    value: 'Asia/Aden',
    label: 'Aden',
  },
  {
    group: 'Asia',
    value: 'Asia/Almaty',
    label: 'Almaty',
  },
  {
    group: 'Asia',
    value: 'Asia/Amman',
    label: 'Amman',
  },
  {
    group: 'Asia',
    value: 'Asia/Anadyr',
    label: 'Anadyr',
  },
  {
    group: 'Asia',
    value: 'Asia/Aqtau',
    label: 'Aqtau',
  },
  {
    group: 'Asia',
    value: 'Asia/Aqtobe',
    label: 'Aqtobe',
  },
  {
    group: 'Asia',
    value: 'Asia/Ashgabat',
    label: 'Ashgabat',
  },
  {
    group: 'Asia',
    value: 'Asia/Baghdad',
    label: 'Baghdad',
  },
  {
    group: 'Asia',
    value: 'Asia/Bahrain',
    label: 'Bahrain',
  },
  {
    group: 'Asia',
    value: 'Asia/Baku',
    label: 'Baku',
  },
  {
    group: 'Asia',
    value: 'Asia/Bangkok',
    label: 'Bangkok',
  },
  {
    group: 'Asia',
    value: 'Asia/Beirut',
    label: 'Beirut',
  },
  {
    group: 'Asia',
    value: 'Asia/Bishkek',
    label: 'Bishkek',
  },
  {
    group: 'Asia',
    value: 'Asia/Brunei',
    label: 'Brunei',
  },
  {
    group: 'Asia',
    value: 'Asia/Choibalsan',
    label: 'Choibalsan',
  },
  {
    group: 'Asia',
    value: 'Asia/Chongqing',
    label: 'Chongqing',
  },
  {
    group: 'Asia',
    value: 'Asia/Colombo',
    label: 'Colombo',
  },
  {
    group: 'Asia',
    value: 'Asia/Damascus',
    label: 'Damascus',
  },
  {
    group: 'Asia',
    value: 'Asia/Dhaka',
    label: 'Dhaka',
  },
  {
    group: 'Asia',
    value: 'Asia/Dili',
    label: 'Dili',
  },
  {
    group: 'Asia',
    value: 'Asia/Dubai',
    label: 'Dubai',
  },
  {
    group: 'Asia',
    value: 'Asia/Dushanbe',
    label: 'Dushanbe',
  },
  {
    group: 'Asia',
    value: 'Asia/Gaza',
    label: 'Gaza',
  },
  {
    group: 'Asia',
    value: 'Asia/Harbin',
    label: 'Harbin',
  },
  {
    group: 'Asia',
    value: 'Asia/Hebron',
    label: 'Hebron',
  },
  {
    group: 'Asia',
    value: 'Asia/Ho_Chi_Minh',
    label: 'Ho Chi Minh',
  },
  {
    group: 'Asia',
    value: 'Asia/Hong_Kong',
    label: 'Hong Kong',
  },
  {
    group: 'Asia',
    value: 'Asia/Hovd',
    label: 'Hovd',
  },
  {
    group: 'Asia',
    value: 'Asia/Irkutsk',
    label: 'Irkutsk',
  },
  {
    group: 'Asia',
    value: 'Asia/Jakarta',
    label: 'Jakarta',
  },
  {
    group: 'Asia',
    value: 'Asia/Jayapura',
    label: 'Jayapura',
  },
  {
    group: 'Asia',
    value: 'Asia/Jerusalem',
    label: 'Jerusalem',
  },
  {
    group: 'Asia',
    value: 'Asia/Kabul',
    label: 'Kabul',
  },
  {
    group: 'Asia',
    value: 'Asia/Kamchatka',
    label: 'Kamchatka',
  },
  {
    group: 'Asia',
    value: 'Asia/Karachi',
    label: 'Karachi',
  },
  {
    group: 'Asia',
    value: 'Asia/Kashgar',
    label: 'Kashgar',
  },
  {
    group: 'Asia',
    value: 'Asia/Kathmandu',
    label: 'Kathmandu',
  },
  {
    group: 'Asia',
    value: 'Asia/Khandyga',
    label: 'Khandyga',
  },
  {
    group: 'Asia',
    value: 'Asia/Kolkata',
    label: 'Kolkata',
  },
  {
    group: 'Asia',
    value: 'Asia/Krasnoyarsk',
    label: 'Krasnoyarsk',
  },
  {
    group: 'Asia',
    value: 'Asia/Kuala_Lumpur',
    label: 'Kuala Lumpur',
  },
  {
    group: 'Asia',
    value: 'Asia/Kuching',
    label: 'Kuching',
  },
  {
    group: 'Asia',
    value: 'Asia/Kuwait',
    label: 'Kuwait',
  },
  {
    group: 'Asia',
    value: 'Asia/Macau',
    label: 'Macau',
  },
  {
    group: 'Asia',
    value: 'Asia/Magadan',
    label: 'Magadan',
  },
  {
    group: 'Asia',
    value: 'Asia/Makassar',
    label: 'Makassar',
  },
  {
    group: 'Asia',
    value: 'Asia/Manila',
    label: 'Manila',
  },
  {
    group: 'Asia',
    value: 'Asia/Muscat',
    label: 'Muscat',
  },
  {
    group: 'Asia',
    value: 'Asia/Nicosia',
    label: 'Nicosia',
  },
  {
    group: 'Asia',
    value: 'Asia/Novokuznetsk',
    label: 'Novokuznetsk',
  },
  {
    group: 'Asia',
    value: 'Asia/Novosibirsk',
    label: 'Novosibirsk',
  },
  {
    group: 'Asia',
    value: 'Asia/Omsk',
    label: 'Omsk',
  },
  {
    group: 'Asia',
    value: 'Asia/Oral',
    label: 'Oral',
  },
  {
    group: 'Asia',
    value: 'Asia/Phnom_Penh',
    label: 'Phnom Penh',
  },
  {
    group: 'Asia',
    value: 'Asia/Pontianak',
    label: 'Pontianak',
  },
  {
    group: 'Asia',
    value: 'Asia/Pyongyang',
    label: 'Pyongyang',
  },
  {
    group: 'Asia',
    value: 'Asia/Qatar',
    label: 'Qatar',
  },
  {
    group: 'Asia',
    value: 'Asia/Qyzylorda',
    label: 'Qyzylorda',
  },
  {
    group: 'Asia',
    value: 'Asia/Rangoon',
    label: 'Rangoon',
  },
  {
    group: 'Asia',
    value: 'Asia/Riyadh',
    label: 'Riyadh',
  },
  {
    group: 'Asia',
    value: 'Asia/Sakhalin',
    label: 'Sakhalin',
  },
  {
    group: 'Asia',
    value: 'Asia/Samarkand',
    label: 'Samarkand',
  },
  {
    group: 'Asia',
    value: 'Asia/Seoul',
    label: 'Seoul',
  },
  {
    group: 'Asia',
    value: 'Asia/Shanghai',
    label: 'Shanghai',
  },
  {
    group: 'Asia',
    value: 'Asia/Singapore',
    label: 'Singapore',
  },
  {
    group: 'Asia',
    value: 'Asia/Taipei',
    label: 'Taipei',
  },
  {
    group: 'Asia',
    value: 'Asia/Tashkent',
    label: 'Tashkent',
  },
  {
    group: 'Asia',
    value: 'Asia/Tbilisi',
    label: 'Tbilisi',
  },
  {
    group: 'Asia',
    value: 'Asia/Tehran',
    label: 'Tehran',
  },
  {
    group: 'Asia',
    value: 'Asia/Thimphu',
    label: 'Thimphu',
  },
  {
    group: 'Asia',
    value: 'Asia/Tokyo',
    label: 'Tokyo',
  },
  {
    group: 'Asia',
    value: 'Asia/Ulaanbaatar',
    label: 'Ulaanbaatar',
  },
  {
    group: 'Asia',
    value: 'Asia/Urumqi',
    label: 'Urumqi',
  },
  {
    group: 'Asia',
    value: 'Asia/Ust-Nera',
    label: 'Ust-Nera',
  },
  {
    group: 'Asia',
    value: 'Asia/Vientiane',
    label: 'Vientiane',
  },
  {
    group: 'Asia',
    value: 'Asia/Vladivostok',
    label: 'Vladivostok',
  },
  {
    group: 'Asia',
    value: 'Asia/Yakutsk',
    label: 'Yakutsk',
  },
  {
    group: 'Asia',
    value: 'Asia/Yekaterinburg',
    label: 'Yekaterinburg',
  },
  {
    group: 'Asia',
    value: 'Asia/Yerevan',
    label: 'Yerevan',
  },
  {
    group: 'Australia',
    value: 'Australia/Adelaide',
    label: 'Adelaide',
  },
  {
    group: 'Australia',
    value: 'Australia/Brisbane',
    label: 'Brisbane',
  },
  {
    group: 'Australia',
    value: 'Australia/Broken_Hill',
    label: 'Broken Hill',
  },
  {
    group: 'Australia',
    value: 'Australia/Currie',
    label: 'Currie',
  },
  {
    group: 'Australia',
    value: 'Australia/Darwin',
    label: 'Darwin',
  },
  {
    group: 'Australia',
    value: 'Australia/Eucla',
    label: 'Eucla',
  },
  {
    group: 'Australia',
    value: 'Australia/Hobart',
    label: 'Hobart',
  },
  {
    group: 'Australia',
    value: 'Australia/Lindeman',
    label: 'Lindeman',
  },
  {
    group: 'Australia',
    value: 'Australia/Lord_Howe',
    label: 'Lord Howe',
  },
  {
    group: 'Australia',
    value: 'Australia/Melbourne',
    label: 'Melbourne',
  },
  {
    group: 'Australia',
    value: 'Australia/Perth',
    label: 'Perth',
  },
  {
    group: 'Australia',
    value: 'Australia/Sydney',
    label: 'Sydney',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Apia',
    label: 'Apia',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Auckland',
    label: 'Auckland',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Chatham',
    label: 'Chatham',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Chuuk',
    label: 'Chuuk',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Easter',
    label: 'Easter',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Efate',
    label: 'Efate',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Enderbury',
    label: 'Enderbury',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Fakaofo',
    label: 'Fakaofo',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Fiji',
    label: 'Fiji',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Funafuti',
    label: 'Funafuti',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Galapagos',
    label: 'Galapagos',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Gambier',
    label: 'Gambier',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Guadalcanal',
    label: 'Guadalcanal',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Guam',
    label: 'Guam',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Johnston',
    label: 'Johnston',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Kiritimati',
    label: 'Kiritimati',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Kosrae',
    label: 'Kosrae',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Kwajalein',
    label: 'Kwajalein',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Majuro',
    label: 'Majuro',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Marquesas',
    label: 'Marquesas',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Midway',
    label: 'Midway',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Nauru',
    label: 'Nauru',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Niue',
    label: 'Niue',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Norfolk',
    label: 'Norfolk',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Noumea',
    label: 'Noumea',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Pago_Pago',
    label: 'Pago Pago',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Palau',
    label: 'Palau',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Pitcairn',
    label: 'Pitcairn',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Pohnpei',
    label: 'Pohnpei',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Port_Moresby',
    label: 'Port Moresby',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Rarotonga',
    label: 'Rarotonga',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Saipan',
    label: 'Saipan',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Tahiti',
    label: 'Tahiti',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Tarawa',
    label: 'Tarawa',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Tongatapu',
    label: 'Tongatapu',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Wake',
    label: 'Wake',
  },
  {
    group: 'Pacific',
    value: 'Pacific/Wallis',
    label: 'Wallis',
  },
  {
    group: 'Atlantic',
    value: 'Atlantic/Azores',
    label: 'Azores',
  },
  {
    group: 'Atlantic',
    value: 'Atlantic/Bermuda',
    label: 'Bermuda',
  },
  {
    group: 'Atlantic',
    value: 'Atlantic/Canary',
    label: 'Canary',
  },
  {
    group: 'Atlantic',
    value: 'Atlantic/Cape_Verde',
    label: 'Cape Verde',
  },
  {
    group: 'Atlantic',
    value: 'Atlantic/Faroe',
    label: 'Faroe',
  },
  {
    group: 'Atlantic',
    value: 'Atlantic/Madeira',
    label: 'Madeira',
  },
  {
    group: 'Atlantic',
    value: 'Atlantic/Reykjavik',
    label: 'Reykjavik',
  },
  {
    group: 'Atlantic',
    value: 'Atlantic/South_Georgia',
    label: 'South Georgia',
  },
  {
    group: 'Atlantic',
    value: 'Atlantic/St_Helena',
    label: 'St Helena',
  },
  {
    group: 'Atlantic',
    value: 'Atlantic/Stanley',
    label: 'Stanley',
  },
  {
    group: 'Indian',
    value: 'Indian/Antananarivo',
    label: 'Antananarivo',
  },
  {
    group: 'Indian',
    value: 'Indian/Chagos',
    label: 'Chagos',
  },
  {
    group: 'Indian',
    value: 'Indian/Christmas',
    label: 'Christmas',
  },
  {
    group: 'Indian',
    value: 'Indian/Cocos',
    label: 'Cocos',
  },
  {
    group: 'Indian',
    value: 'Indian/Comoro',
    label: 'Comoro',
  },
  {
    group: 'Indian',
    value: 'Indian/Kerguelen',
    label: 'Kerguelen',
  },
  {
    group: 'Indian',
    value: 'Indian/Mahe',
    label: 'Mahe',
  },
  {
    group: 'Indian',
    value: 'Indian/Maldives',
    label: 'Maldives',
  },
  {
    group: 'Indian',
    value: 'Indian/Mauritius',
    label: 'Mauritius',
  },
  {
    group: 'Indian',
    value: 'Indian/Mayotte',
    label: 'Mayotte',
  },
  {
    group: 'Indian',
    value: 'Indian/Reunion',
    label: 'Reunion',
  },
  {
    group: 'Africa',
    value: 'Africa/Abidjan',
    label: 'Abidjan',
  },
  {
    group: 'Africa',
    value: 'Africa/Accra',
    label: 'Accra',
  },
  {
    group: 'Africa',
    value: 'Africa/Addis_Ababa',
    label: 'Addis Ababa',
  },
  {
    group: 'Africa',
    value: 'Africa/Algiers',
    label: 'Algiers',
  },
  {
    group: 'Africa',
    value: 'Africa/Asmara',
    label: 'Asmara',
  },
  {
    group: 'Africa',
    value: 'Africa/Bamako',
    label: 'Bamako',
  },
  {
    group: 'Africa',
    value: 'Africa/Bangui',
    label: 'Bangui',
  },
  {
    group: 'Africa',
    value: 'Africa/Banjul',
    label: 'Banjul',
  },
  {
    group: 'Africa',
    value: 'Africa/Bissau',
    label: 'Bissau',
  },
  {
    group: 'Africa',
    value: 'Africa/Blantyre',
    label: 'Blantyre',
  },
  {
    group: 'Africa',
    value: 'Africa/Brazzaville',
    label: 'Brazzaville',
  },
  {
    group: 'Africa',
    value: 'Africa/Bujumbura',
    label: 'Bujumbura',
  },
  {
    group: 'Africa',
    value: 'Africa/Cairo',
    label: 'Cairo',
  },
  {
    group: 'Africa',
    value: 'Africa/Casablanca',
    label: 'Casablanca',
  },
  {
    group: 'Africa',
    value: 'Africa/Ceuta',
    label: 'Ceuta',
  },
  {
    group: 'Africa',
    value: 'Africa/Conakry',
    label: 'Conakry',
  },
  {
    group: 'Africa',
    value: 'Africa/Dakar',
    label: 'Dakar',
  },
  {
    group: 'Africa',
    value: 'Africa/Dar_es_Salaam',
    label: 'Dar es Salaam',
  },
  {
    group: 'Africa',
    value: 'Africa/Djibouti',
    label: 'Djibouti',
  },
  {
    group: 'Africa',
    value: 'Africa/Douala',
    label: 'Douala',
  },
  {
    group: 'Africa',
    value: 'Africa/El_Aaiun',
    label: 'El Aaiun',
  },
  {
    group: 'Africa',
    value: 'Africa/Freetown',
    label: 'Freetown',
  },
  {
    group: 'Africa',
    value: 'Africa/Gaborone',
    label: 'Gaborone',
  },
  {
    group: 'Africa',
    value: 'Africa/Harare',
    label: 'Harare',
  },
  {
    group: 'Africa',
    value: 'Africa/Johannesburg',
    label: 'Johannesburg',
  },
  {
    group: 'Africa',
    value: 'Africa/Juba',
    label: 'Juba',
  },
  {
    group: 'Africa',
    value: 'Africa/Kampala',
    label: 'Kampala',
  },
  {
    group: 'Africa',
    value: 'Africa/Khartoum',
    label: 'Khartoum',
  },
  {
    group: 'Africa',
    value: 'Africa/Kigali',
    label: 'Kigali',
  },
  {
    group: 'Africa',
    value: 'Africa/Kinshasa',
    label: 'Kinshasa',
  },
  {
    group: 'Africa',
    value: 'Africa/Lagos',
    label: 'Lagos',
  },
  {
    group: 'Africa',
    value: 'Africa/Libreville',
    label: 'Libreville',
  },
  {
    group: 'Africa',
    value: 'Africa/Lome',
    label: 'Lome',
  },
  {
    group: 'Africa',
    value: 'Africa/Luanda',
    label: 'Luanda',
  },
  {
    group: 'Africa',
    value: 'Africa/Lubumbashi',
    label: 'Lubumbashi',
  },
  {
    group: 'Africa',
    value: 'Africa/Lusaka',
    label: 'Lusaka',
  },
  {
    group: 'Africa',
    value: 'Africa/Malabo',
    label: 'Malabo',
  },
  {
    group: 'Africa',
    value: 'Africa/Maputo',
    label: 'Maputo',
  },
  {
    group: 'Africa',
    value: 'Africa/Maseru',
    label: 'Maseru',
  },
  {
    group: 'Africa',
    value: 'Africa/Mbabane',
    label: 'Mbabane',
  },
  {
    group: 'Africa',
    value: 'Africa/Mogadishu',
    label: 'Mogadishu',
  },
  {
    group: 'Africa',
    value: 'Africa/Monrovia',
    label: 'Monrovia',
  },
  {
    group: 'Africa',
    value: 'Africa/Nairobi',
    label: 'Nairobi',
  },
  {
    group: 'Africa',
    value: 'Africa/Ndjamena',
    label: 'Ndjamena',
  },
  {
    group: 'Africa',
    value: 'Africa/Niamey',
    label: 'Niamey',
  },
  {
    group: 'Africa',
    value: 'Africa/Nouakchott',
    label: 'Nouakchott',
  },
  {
    group: 'Africa',
    value: 'Africa/Ouagadougou',
    label: 'Ouagadougou',
  },
  {
    group: 'Africa',
    value: 'Africa/Porto-Novo',
    label: 'Porto-Novo',
  },
  {
    group: 'Africa',
    value: 'Africa/Sao_Tome',
    label: 'Sao Tome',
  },
  {
    group: 'Africa',
    value: 'Africa/Tripoli',
    label: 'Tripoli',
  },
  {
    group: 'Africa',
    value: 'Africa/Tunis',
    label: 'Tunis',
  },
  {
    group: 'Africa',
    value: 'Africa/Windhoek',
    label: 'Windhoek',
  },
];

export const TIME_ZONES_ORDER = [
  { value: 'US', label: 'US' },
  { value: 'Canada', label: 'Canada' },
  { value: 'Mexico', label: 'Mexico' },
  { value: 'Americas', label: 'Americas' },
  { value: 'Argentina', label: 'Argentina' },
  { value: 'Europe', label: 'Europe' },
  { value: 'Asia', label: 'Asia' },
  { value: 'Australia', label: 'Australia' },
  { value: 'Pacific', label: 'Pacific' },
  { value: 'Atlantic', label: 'Atlantic' },
  { value: 'Indian', label: 'Indian' },
  { value: 'Africa', label: 'Africa' },
];

export const MAX_NOTE_NAME_LENGTH = 70;
export const MAX_SHARE_NOTE_NAME_LENGTH = 24;

export const NOTE_RESTRICTIONS = [
  {
    label: 'None',
    value: 'None',
  },
  {
    label: 'Visible to org members only',
    value: 'VisibleToOrgMembersOnly',
  },
  {
    label: 'Client editing locked',
    value: 'ClientEditingLocked',
  },
];

export const SURVERY_OPTIONS = [
  {
    value: 'facebook',
    label: 'Facebook',
  },
  {
    value: 'industryEvent',
    label: 'Industry Event',
  },
  {
    value: 'instagram',
    label: 'Instagram',
  },
  {
    value: 'internetSearch',
    label: 'Internet Search',
  },
  {
    value: 'onlineAd',
    label: 'Online Ad',
  },
  {
    value: 'proPartner',
    label: 'Pro-Partner / Affiliate Link',
  },
  {
    value: 'referralFriend',
    label: 'Referral / Friend',
  },
  {
    value: 'returnCustomer',
    label: 'I am a Return Customer',
  },
  {
    value: 'other',
    label: 'Other',
  },
];

export const SURVERY_EVENTS_OPTIONS = [
  {
    value: 'less_than_25_events',
    label: 'Less than 25 events per year',
  },
  {
    value: '25_75_events',
    label: '25 - 75 events per year',
  },
  {
    value: 'more_than_75_events',
    label: 'More than 75 events per year',
  },
];

export const SURVEY_PLAN_TO_USE_OPTIONS = [
  {
    value: 'sales',
    label: 'Sales',
  },
  {
    value: 'pm',
    label: 'Project Management',
  },
  {
    value: 'sales_pm',
    label: 'Sales & Project Management',
  },
];

export const SURVEY_YEARS_IN_BUSINESS_OPTIONS = [
  {
    value: '0_1_years',
    label: '0-1 year',
  },
  {
    value: '1_5_years',
    label: '1-5 years',
  },
  {
    value: '5_10_years',
    label: '5-10 years',
  },
  {
    value: '10_plus_years',
    label: '10+ years',
  },
];

export const STATES = [
  {
    label: 'Alabama',
    value: 'AL',
  },
  {
    label: 'Alaska',
    value: 'AK',
  },
  {
    label: 'Arizona',
    value: 'AZ',
  },
  {
    label: 'Arkansas',
    value: 'AR',
  },
  {
    label: 'California',
    value: 'CA',
  },
  {
    label: 'Colorado',
    value: 'CO',
  },
  {
    label: 'Connecticut',
    value: 'CT',
  },
  {
    label: 'Delaware',
    value: 'DE',
  },
  {
    label: 'District Of Columbia',
    value: 'DC',
  },
  {
    label: 'Florida',
    value: 'FL',
  },
  {
    label: 'Georgia',
    value: 'GA',
  },
  {
    label: 'Hawaii',
    value: 'HI',
  },
  {
    label: 'Idaho',
    value: 'ID',
  },
  {
    label: 'Illinois',
    value: 'IL',
  },
  {
    label: 'Indiana',
    value: 'IN',
  },
  {
    label: 'Iowa',
    value: 'IA',
  },
  {
    label: 'Kansas',
    value: 'KS',
  },
  {
    label: 'Kentucky',
    value: 'KY',
  },
  {
    label: 'Louisiana',
    value: 'LA',
  },
  {
    label: 'Maine',
    value: 'ME',
  },
  {
    label: 'Maryland',
    value: 'MD',
  },
  {
    label: 'Massachusetts',
    value: 'MA',
  },
  {
    label: 'Michigan',
    value: 'MI',
  },
  {
    label: 'Minnesota',
    value: 'MN',
  },
  {
    label: 'Mississippi',
    value: 'MS',
  },
  {
    label: 'Missouri',
    value: 'MO',
  },
  {
    label: 'Montana',
    value: 'MT',
  },
  {
    label: 'Nebraska',
    value: 'NE',
  },
  {
    label: 'Nevada',
    value: 'NV',
  },
  {
    label: 'New Hampshire',
    value: 'NH',
  },
  {
    label: 'New Jersey',
    value: 'NJ',
  },
  {
    label: 'New Mexico',
    value: 'NM',
  },
  {
    label: 'New York',
    value: 'NY',
  },
  {
    label: 'North Carolina',
    value: 'NC',
  },
  {
    label: 'North Dakota',
    value: 'ND',
  },
  {
    label: 'Ohio',
    value: 'OH',
  },
  {
    label: 'Oklahoma',
    value: 'OK',
  },
  {
    label: 'Oregon',
    value: 'OR',
  },
  {
    label: 'Pennsylvania',
    value: 'PA',
  },
  {
    label: 'Rhode Island',
    value: 'RI',
  },
  {
    label: 'South Carolina',
    value: 'SC',
  },
  {
    label: 'South Dakota',
    value: 'SD',
  },
  {
    label: 'Tennessee',
    value: 'TN',
  },
  {
    label: 'Texas',
    value: 'TX',
  },
  {
    label: 'Utah',
    value: 'UT',
  },
  {
    label: 'Vermont',
    value: 'VT',
  },
  {
    label: 'Virginia',
    value: 'VA',
  },
  {
    label: 'Washington',
    value: 'WA',
  },
  {
    label: 'West Virginia',
    value: 'WV',
  },
  {
    label: 'Wisconsin',
    value: 'WI',
  },
  {
    label: 'Wyoming',
    value: 'WY',
  },
  {
    label: 'Puerto Rico',
    value: 'PR',
  },
];

export const EVENT_TYPES = [
  { value: 'showEvents', label: 'Calendar Events' },
  { value: 'showChecklist', label: 'Checklist Items' },
  { value: 'showPayments', label: 'Payments' },
  { value: 'showBookings', label: 'Tentative Bookings' },
];

export const CALENDAR_VIEW_OPTIONS = EVENT_TYPES.reduce((acc, type) => {
  acc[type.value] = true;
  return acc;
}, {
  firstDayOfWeek: 0,
  weddingExclusions: [],
});
